import React from "react";
import { useTranslation, Trans } from "react-i18next";

import {
  Modal,
  Image,
  Button
} from '@lockerpm/design';

import VerifyIcon from '../../../../../assets/images/icons/congrats.svg'

const VerifyModal = (props) => {
  const { t } = useTranslation();
  const {
    visible = false,
    availablePercent = 1,
    remainPercent = 0,
    modalData = {
      action: '',
      store: '',
      percent: 5
    },
    onClose = () => {},
    onGetCode = () => {}
  } = props;

  return (
    <Modal
      title={<></>}
      open={visible}
      width={430}
      footer={false}
      onCancel={() => onClose()}
    >
      <div className="flex items-center justify-center">
        <Image
          src={VerifyIcon}
          preview={false}
        />
      </div>
      <div className="text-center mt-5">
        <div className="text-xl font-semibold mb-5">
          {t('rewards.verify_popup.congrats') }
        </div>
        {
          remainPercent > availablePercent && <div className="text-center">
            <div className="mb-5">
              <Trans
                i18nKey={'rewards.verify_popup.congrats_desc1'}
                values={{
                  action: modalData.action,
                  percent: modalData.percent,
                  current_discount: availablePercent,
                  remain_percent: remainPercent
                }}
                components={{
                  b: <b className="font-semibold"/>
                }}
              />
            </div>
            <Button
              type="primary"
              onClick={() => onClose()} 
            >
              {t('rewards.verify_popup.continue')}
            </Button>
          </div>
        }
        {
          remainPercent <= availablePercent && <div className="text-center">
            <div className="mb-5">
              <Trans
                i18nKey={'rewards.verify_popup.congrats_desc2'}
                values={{
                  action: modalData.action,
                  percent: modalData.percent,
                  current_discount: availablePercent
                }}
                components={{
                  b: <b className="font-semibold"/>
                }}
              />
            </div>
            <Button
              type="primary"
              size="large"
              onClick={() => onGetCode()} 
            >
              {t('rewards.get_code.title')}
            </Button>
          </div>
        }
      </div>
    </Modal>
  );
}

export default VerifyModal;